// Custom GTM event tracking for the B2B corporate-gifting funnel.
//
// Replaces the retired Universal Analytics ga('send', 'event', ...) calls with
// dataLayer.push so the events are picked up by Google Tag Manager (GTM-TC4FCT4).
// Uses event delegation on `document` instead of binding at top-level, so the
// handlers work regardless of script load timing (defer) and also fire for
// elements rendered/replaced after initial load (e.g. AJAX content).
(function () {
  function pushEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) {
      return;
    }

    // Request Catalogue
    if (target.closest('.request-button')) {
      pushEvent({
        event: 'request_catalogue_click',
        eventCategory: 'Request Catalogue',
        eventAction: 'Click',
        eventLabel: 'Mailto Catalogue',
      });
      return;
    }

    // Contact Form (submit button click)
    if (target.closest('.contact-form-submit')) {
      pushEvent({
        event: 'corporate_contact_form_submit',
        eventCategory: 'Corporate Concierge Contact Form',
        eventAction: 'Sign Up',
        eventLabel: 'Successful Form Submission',
      });
      return;
    }

    // Contact Bar Phone
    if (target.closest('.contact-bar-phone')) {
      pushEvent({
        event: 'phone_number_click',
        eventCategory: 'Phone Number Click',
        eventAction: 'Click',
        eventLabel: 'Phone Number',
      });
      return;
    }

    // Contact Bar Email
    if (target.closest('.contact-bar-email')) {
      pushEvent({
        event: 'contact_support_click',
        eventCategory: 'Contact Support',
        eventAction: 'Click',
        eventLabel: 'Mailto Support',
      });
    }
  });
})();
